export default {
  sendFeedback: (action) => {
    dataLayerPush({
      event: 'reviewEvent',
      target: 'hjälpte informationen dig',
      action
    })
  },
  contactUs: (label) => {
    dataLayerPush({
      event: 'contactsubmitEvent',
      target: 'kontakta oss',
      action: 'inskickad',
      label
    })
  },
  contactUsHelp: (label) => {
    dataLayerPush({
      event: 'contactHelpLinkEvent',
      target: 'kontakta oss - hjälp',
      action: 'klick på CTA',
      label
    })
  },
  contactUsFaqLink: (action, label) => {
    dataLayerPush({
      event: 'contactFaqLinkEvent',
      target: 'kontakta oss - faq länk',
      action,
      label
    })
  },
  contactUsFaqShow: (label) => {
    dataLayerPush({
      event: 'contactFaqShowEvent',
      target: 'kontakta oss - faq visad',
      action: 'visad',
      label
    })
  },
  printDeliverySiteInformation: (isCorporate) => {
    dataLayerPush({
      event: 'printDeliverySiteInformationEvent',
      target: isCorporate ? 'energikonto' : 'mina sidor',
      action: 'klick',
      label: 'anläggningsdata skriv ut'
    })
  }
}

const dataLayerPush = (obj) => {
  window.dataLayer = window.dataLayer ? window.dataLayer : []
  window.dataLayer.push(obj)
}
